import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Icon } from "@iconify/react";
import { MainLoginPage } from "./MainLoginPage/MainLoginPage";
import { StaffLoginPage } from "./StaffLoginPage/StaffLoginPage";
import { ForgotPassword } from "./ForgotPassword/ForgotPassword";
import { Signup } from "./Signup/Signup";

export const WebLoginPage = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(()=>{
    if(approveId){
        return;
    }
    navigate(`/dedicated/magp/login?activeTab=webLoginPage&subActiveTab=${query.get('subActiveTab') || 'mainLoginPage'}`, {
        replace: true,
    });
  },[])

  const items = [
    {
      label: "Main Login Page",
      key: "mainLoginPage",
      children: <MainLoginPage />,
    },
    {
        label: "Vendor Login Page",
        key: "vendorLoginPage",
        children: <StaffLoginPage />,
    },
    {
      label: "Forgot Password",
      key: "forgotPassword",
      children: <ForgotPassword />,
    },
    {
      label: "Signup",
      key: "signUp",
      children: <Signup />,
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
